// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  height: 54px;
  color: var(--contrast-text-color);
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  display: flex;
  align-items: center;
}

.container {
  display: flex;
  justify-content: center;
}
.container .block {
  margin-bottom: 24px;
}
.container .block .title {
  display: flex;
  margin-bottom: 8px;
}
.container .block .title h4 {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  display: flex;
  align-items: center;
}

.input-container {
  display: flex;
  width: 100%;
  color: var(--text-color);
}
.input-container .label {
  width: 192px;
  margin-right: 8px;
  text-transform: uppercase;
  display: flex;
  align-items: baseline;
}
.input-container .value {
  flex: 1;
  color: var(--contrast-text-color);
}
.input-container .value .item-list {
  display: flex;
  height: 32px;
  align-items: center;
}

.activity {
  margin-bottom: 8px;
}
.activity > div:first-child {
  color: var(--contrast-text-color);
}

.buttons {
  display: flex;
  justify-content: flex-end;
  margin-right: 6px;
}

.form {
  padding: 8px 6px 0 48px;
}

.subscription {
  display: flex;
  padding-left: 48px;
}
.subscription .name {
  margin-right: 4px;
}
.subscription .icon i {
  margin-right: 4px;
  display: inline-block;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
